// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3li36","right":"styles_right__BQN5M"};